import { resolve } from 'styled-jsx/css';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import tapEvent, { FooterAction } from 'lib/Tracking/Footer/TapEvent';
import useEvents from 'lib/hooks/useEvents';
import { SourcePages } from 'lib/EventSchema';
import Link, { css } from './Link';

/* istanbul ignore next */
const aCss = resolve`
a {
  font-weight: 300;
}
`;

const LINKS = Object.freeze([
  { href: '/about-us', title: 'footer.about', trackingSection: 'about' },
  { href: '/about-us#jobs', title: 'footer.careers', trackingSection: 'careers' },
  { href: '/engineering', title: 'footer.engineering', trackingSection: 'engineering' },
  { href: '/about-us#team', title: 'footer.ourTeam', trackingSection: 'our_team' },
  {
    href: '/news-and-analysis',
    title: 'header.newsAndAnalysis',
    trackingSection: 'news_and_analysis',
  },
  { href: '/guides', title: 'header.guidesAndReviews', trackingSection: 'guides_and_reviews' },
]);

interface CompanyLinksProps {
  className: string;
}

export default function CompanyLinks({ className }: CompanyLinksProps): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const { asPath } = useRouter();

  function logFooterTapEvent(action: FooterAction): void {
    logger.log(tapEvent({ action, pathName: asPath as SourcePages }));
  }

  return (
    <ul className={`links ${className}`} role="navigation">
      {LINKS.map(({ href, title, trackingSection }) => (
        <li key={title}>
          <Link
            href={href}
            onClick={(): void => {
              logFooterTapEvent(trackingSection as FooterAction);
            }}
            className={aCss.className}
          >
            {t(title)}
          </Link>
        </li>
      ))}
      <li>
        <a
          href="mailto:help@autolist.com?subject=Autolist%20Inquiry"
          onClick={(): void => {
            logFooterTapEvent('contact');
          }}
          className={`${aCss.className} ${css.className}`}
        >
          {t('footer.contact')}
        </a>
      </li>
      <li>
        <Link
          href="/used-car-to-dream-car-scholarship"
          onClick={(): void => {
            logFooterTapEvent('scholarship');
          }}
          className={aCss.className}
        >
          {t('footer.scholarship')}
        </Link>
      </li>
      {aCss.styles}
      <style jsx>
        {`
          ul {
            width: 100%;
            list-style: none;
            padding: 0;
          }

          .links {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            padding: 0px 0px 0px 0px;
            margin-bottom: 0;
            grid-template-rows: 0.1fr 0.1fr 0.1fr 0.1fr;
          }
        `}
      </style>
      {css.styles}
    </ul>
  );
}
